import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type InitializeSignoffResponseViaPasswordResponse = {
   token: string;
};

export async function initializeSignoffResponseViaPassword(
   signoffRequestId: number,
   login: string,
   password: string,
   common: CommonRequestOptions = {}
): Promise<InitializeSignoffResponseViaPasswordResponse> {
   return await makeRequest(
      'post',
      `courses/stage-sign-offs/responses/${signoffRequestId}/initializeViaPassword`,
      {
         ...common,
         body: {
            login,
            password,
         },
      }
   );
}
